import { render } from "./InputAge.vue?vue&type=template&id=254f2f0d"
import script from "./InputAge.vue?vue&type=script&lang=js"
export * from "./InputAge.vue?vue&type=script&lang=js"
script.render = render

export default script